export const ALGOLIA_APP = 'U8IN8B8KWW';
export const ALGOLIA_SEARCH_KEY = '4a3c1bc751fc7d2f3c6a1ad6f9f1f7c5';
export const ALGOLIA_INDEX = 'products';
export const ALGOLIA_RECOMMEND_THRESHOLD = 10;
